<div class="player" *ngIf="metaData && isOpen" (click)="close()">
    <iframe class="player__iframe" [width]="metaData.width" [height]="metaData.height" class="player__iframe" [src]="playerSrc" frameborder="0"
            allow="autoplay; fullscreen; picture-in-picture" [title]="metaData.title"></iframe>
</div>
